import {SeasonStats} from "./seasonStats";
import {Event} from "./event";

export class EventStats {
  event: Event;
  seasonStats: SeasonStats[];
}
